const Profile = async () =>
    import('../../pages/profile/Edit').then((module) => ({
        Component: module.ProfilePage,
    }));
const CompanyProfileViewPage = async () =>
    import('../../pages/company-profile/CompanyProfileView').then((module) => ({
        Component: module.CompanyProfileView,
    }));
const NotificationRedirect = async () =>
    import('../../layout/Notifications/NotificationRedirect').then((module) => ({
        Component: module.NotificationRedirect,
    }));

const getUserRoutes = (user, features) => {
    const canManageAccessSecurity = features?.sso_auth && Boolean(user?.isAppAdmin);

    return [
        {
            paths: ['/profile/', '/notifications-preferences/'],
            lazy: Profile,
        },
        {
            path: '/company/profile',
            lazy: CompanyProfileViewPage,
            redirectFrom: ['/company-profile'],
        },
        {
            path: '/company/coworkers',
            lazy: CompanyProfileViewPage,
        },
        {
            path: '/company/api-keys',
            lazy: CompanyProfileViewPage,
        },
        {
            path: '/company/access-security/',
            lazy: CompanyProfileViewPage,
            redirectFrom: ['/company/access-security'],
            condition: canManageAccessSecurity,
        },
        {
            path: '/company/access-security/sso/',
            lazy: CompanyProfileViewPage,
            redirectFrom: ['/company/access-security/sso', '/settings/access-security'],
            condition: canManageAccessSecurity,
        },
        {
            path: '/notifications/',
            lazy: NotificationRedirect,
            redirectFrom: ['/notifications'],
        },
    ];
};

export { getUserRoutes };
